module.exports = __webpack_public_path__ + "static/media/earlexLogo.c860906f.png";